/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateOrganisationQuoteCategoryTextsMutationVariables = Types.Exact<{
  input: Types.CreateOrganisationQuoteCategoryTextsInput;
}>;


export type CreateOrganisationQuoteCategoryTextsMutation = { createOrganisationQuoteCategoryTexts: { __typename: 'CreateOrganisationQuoteCategoryTextsResult', quoteCategoryTexts: { __typename: 'OrganisationQuoteCategoryTexts', id: string, categoryIds: Array<string>, opening?: string | null, closing?: string | null }, documentSettings: { __typename: 'DocumentSettings', id: string, quoteCategoryTexts: Array<{ __typename: 'OrganisationQuoteCategoryTexts', id: string, categoryIds: Array<string>, opening?: string | null, closing?: string | null }> } } };

export type ModifyOrganisationQuoteCategoryTextsMutationVariables = Types.Exact<{
  input: Types.ModifyOrganisationQuoteCategoryTextsInput;
}>;


export type ModifyOrganisationQuoteCategoryTextsMutation = { modifyOrganisationQuoteCategoryTexts: { __typename: 'ModifyOrganisationQuoteCategoryTextsResult', quoteCategoryTexts?: { __typename: 'OrganisationQuoteCategoryTexts', id: string, categoryIds: Array<string>, opening?: string | null, closing?: string | null } | null, documentSettings: { __typename: 'DocumentSettings', id: string, quoteCategoryTexts: Array<{ __typename: 'OrganisationQuoteCategoryTexts', id: string, categoryIds: Array<string>, opening?: string | null, closing?: string | null }> } } };

export type DeleteOrganisationQuoteCategoryTextsMutationVariables = Types.Exact<{
  input: Types.DeleteOrganisationQuoteCategoryTextsInput;
}>;


export type DeleteOrganisationQuoteCategoryTextsMutation = { deleteOrganisationQuoteCategoryTexts: { __typename: 'DeleteOrganisationQuoteCategoryTextsResult', documentSettings: { __typename: 'DocumentSettings', id: string, quoteCategoryTexts: Array<{ __typename: 'OrganisationQuoteCategoryTexts', id: string, categoryIds: Array<string>, opening?: string | null, closing?: string | null }> } } };


export const CreateOrganisationQuoteCategoryTextsDocument = gql`
    mutation CreateOrganisationQuoteCategoryTexts($input: CreateOrganisationQuoteCategoryTextsInput!) {
  createOrganisationQuoteCategoryTexts(input: $input) {
    quoteCategoryTexts {
      id
      categoryIds
      opening
      closing
    }
    documentSettings {
      id
      quoteCategoryTexts {
        id
        categoryIds
        opening
        closing
      }
    }
  }
}
    `;
export type CreateOrganisationQuoteCategoryTextsMutationFn = Apollo.MutationFunction<CreateOrganisationQuoteCategoryTextsMutation, CreateOrganisationQuoteCategoryTextsMutationVariables>;

/**
 * __useCreateOrganisationQuoteCategoryTextsMutation__
 *
 * To run a mutation, you first call `useCreateOrganisationQuoteCategoryTextsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganisationQuoteCategoryTextsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganisationQuoteCategoryTextsMutation, { data, loading, error }] = useCreateOrganisationQuoteCategoryTextsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganisationQuoteCategoryTextsMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganisationQuoteCategoryTextsMutation, CreateOrganisationQuoteCategoryTextsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganisationQuoteCategoryTextsMutation, CreateOrganisationQuoteCategoryTextsMutationVariables>(CreateOrganisationQuoteCategoryTextsDocument, options);
      }
export type CreateOrganisationQuoteCategoryTextsMutationHookResult = ReturnType<typeof useCreateOrganisationQuoteCategoryTextsMutation>;
export type CreateOrganisationQuoteCategoryTextsMutationResult = Apollo.MutationResult<CreateOrganisationQuoteCategoryTextsMutation>;
export type CreateOrganisationQuoteCategoryTextsMutationOptions = Apollo.BaseMutationOptions<CreateOrganisationQuoteCategoryTextsMutation, CreateOrganisationQuoteCategoryTextsMutationVariables>;
export const ModifyOrganisationQuoteCategoryTextsDocument = gql`
    mutation ModifyOrganisationQuoteCategoryTexts($input: ModifyOrganisationQuoteCategoryTextsInput!) {
  modifyOrganisationQuoteCategoryTexts(input: $input) {
    quoteCategoryTexts {
      id
      categoryIds
      opening
      closing
    }
    documentSettings {
      id
      quoteCategoryTexts {
        id
        categoryIds
        opening
        closing
      }
    }
  }
}
    `;
export type ModifyOrganisationQuoteCategoryTextsMutationFn = Apollo.MutationFunction<ModifyOrganisationQuoteCategoryTextsMutation, ModifyOrganisationQuoteCategoryTextsMutationVariables>;

/**
 * __useModifyOrganisationQuoteCategoryTextsMutation__
 *
 * To run a mutation, you first call `useModifyOrganisationQuoteCategoryTextsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyOrganisationQuoteCategoryTextsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyOrganisationQuoteCategoryTextsMutation, { data, loading, error }] = useModifyOrganisationQuoteCategoryTextsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useModifyOrganisationQuoteCategoryTextsMutation(baseOptions?: Apollo.MutationHookOptions<ModifyOrganisationQuoteCategoryTextsMutation, ModifyOrganisationQuoteCategoryTextsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifyOrganisationQuoteCategoryTextsMutation, ModifyOrganisationQuoteCategoryTextsMutationVariables>(ModifyOrganisationQuoteCategoryTextsDocument, options);
      }
export type ModifyOrganisationQuoteCategoryTextsMutationHookResult = ReturnType<typeof useModifyOrganisationQuoteCategoryTextsMutation>;
export type ModifyOrganisationQuoteCategoryTextsMutationResult = Apollo.MutationResult<ModifyOrganisationQuoteCategoryTextsMutation>;
export type ModifyOrganisationQuoteCategoryTextsMutationOptions = Apollo.BaseMutationOptions<ModifyOrganisationQuoteCategoryTextsMutation, ModifyOrganisationQuoteCategoryTextsMutationVariables>;
export const DeleteOrganisationQuoteCategoryTextsDocument = gql`
    mutation DeleteOrganisationQuoteCategoryTexts($input: DeleteOrganisationQuoteCategoryTextsInput!) {
  deleteOrganisationQuoteCategoryTexts(input: $input) {
    documentSettings {
      id
      quoteCategoryTexts {
        id
        categoryIds
        opening
        closing
      }
    }
  }
}
    `;
export type DeleteOrganisationQuoteCategoryTextsMutationFn = Apollo.MutationFunction<DeleteOrganisationQuoteCategoryTextsMutation, DeleteOrganisationQuoteCategoryTextsMutationVariables>;

/**
 * __useDeleteOrganisationQuoteCategoryTextsMutation__
 *
 * To run a mutation, you first call `useDeleteOrganisationQuoteCategoryTextsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganisationQuoteCategoryTextsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganisationQuoteCategoryTextsMutation, { data, loading, error }] = useDeleteOrganisationQuoteCategoryTextsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOrganisationQuoteCategoryTextsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganisationQuoteCategoryTextsMutation, DeleteOrganisationQuoteCategoryTextsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganisationQuoteCategoryTextsMutation, DeleteOrganisationQuoteCategoryTextsMutationVariables>(DeleteOrganisationQuoteCategoryTextsDocument, options);
      }
export type DeleteOrganisationQuoteCategoryTextsMutationHookResult = ReturnType<typeof useDeleteOrganisationQuoteCategoryTextsMutation>;
export type DeleteOrganisationQuoteCategoryTextsMutationResult = Apollo.MutationResult<DeleteOrganisationQuoteCategoryTextsMutation>;
export type DeleteOrganisationQuoteCategoryTextsMutationOptions = Apollo.BaseMutationOptions<DeleteOrganisationQuoteCategoryTextsMutation, DeleteOrganisationQuoteCategoryTextsMutationVariables>;